// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress--VY8aP","wave":"wave--LDQVg","menu":"menu--gHmS5"};